import { IAxeCreationData } from "@/lib/interfaces and Enums/InterfaceAxes";
import importedAxesStore from "./generateAxeStore";

export function addAxeToStore(incomingAxes: IAxeCreationData[]) {
  const currentAxeImports = importedAxesStore.getState().allImportedAxes;
  const newAxeData = [...currentAxeImports, ...incomingAxes];

  importedAxesStore.getState().setAllGeneratedAxes(newAxeData);
}
